'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

var _shared = require('../shared');

var _scales = require('../foundational-styles/scales');

var _scales2 = _interopRequireDefault(_scales);

var _palette = require('../foundational-styles/palette');

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectAppearances = {};

SelectAppearances.default = _themer.Themer.createSelectAppearance({
  base: _shared.defaultControlStyles.base,
  disabled: _shared.defaultControlStyles.disabled,
  invalid: {
    boxShadow: 'inset 0 0 0 1px ' + _palette2.default.red.base + ', inset 0 1px 2px ' + _scales2.default.neutral.N4A
  },
  hover: _shared.defaultControlStyles.hover,
  focus: _shared.defaultControlStyles.focus,
  active: _shared.defaultControlStyles.active
});

/**
 * Get the appearance of a `Select`.
 * @param {string} appearance
 * @return {string} the appearance object.
 */
var getSelectAppearance = function getSelectAppearance() {
  return SelectAppearances.default;
};

/**
 * Get the className of a `Select`.
 * @param {string} appearance
 * @return {string} the appearance class name.
 */
exports.default = (0, _memoizeClassName2.default)(getSelectAppearance);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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